export default "__VITE_ASSET__Dgi9Wk2n__"